// 导入 抽取的 请求对象
import ajaxRequest from '@/utils/request';

const introduce = 'useradmin/Introduce';
const home = 'useradmin/Home';

// // 获取今日推荐的客户数量
// export function todayIntroduceApi(areaId) {
//   return ajaxRequest({
//     url: introduce + '/todayIntroduce/' + areaId,
//     method: 'GET',
//     // 跨域 是否携带 cookie
//     withCredentials: true,
//   });
// }
// // 获取今日已到访客户数量
// export function todayVisitedApi(areaId) {
//   return ajaxRequest({
//     url: introduce + '/todayVisited/' + areaId,
//     method: 'GET',
//     // 跨域 是否携带 cookie
//     withCredentials: true,
//   });
// }

// // 获取今日已成交客户数量（包含已签约租、已签约售）
// export function todayTransedApi(areaId) {
//   return ajaxRequest({
//     url: introduce + '/todayTransed/' + areaId,
//     method: 'GET',
//     // 跨域 是否携带 cookie
//     withCredentials: true,
//   });
// }

// // 获取今日注册的用户数量
// export function todayRegisterApi(areaId) {
//   return ajaxRequest({
//     url: home + '/todayRegister/' + areaId,
//     method: 'GET',
//     // 跨域 是否携带 cookie
//     withCredentials: true,
//   });
// }

// // 获取今日推荐的客户数量
// useradmin/Introduce/todayIntroduce/{areaId}

// // 获取今日已到访客户数量
// useradmin/Introduce/todayVisited/{areaId}

// // 获取今日已成交客户数量（包含已签约租、已签约售）
// useradmin/Introduce/todayTransed/{areaId}

// // 获取今日注册的用户数量
// useradmin/Home/todayRegister/{areaId}

// // 获取总的用户数量
// useradmin/Home/totalCustomer/{areaId}

// 请求方法：GET

// areaId都必填

// 获取 最近时间段 推荐的客户数量
export function timeRangIntroduceApi(data) {
  return ajaxRequest({
    url: introduce + '/timeRangIntroduce',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取 最近时间段 已到访客户数量
export function timeRangVisitedApi(data) {
  return ajaxRequest({
    url: introduce + '/timeRangVisited',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取 最近时间段 已成交客户数量（包含已签约租、已签约售）
export function timeRangTransedApi(data) {
  return ajaxRequest({
    url: introduce + '/timeRangTransed',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

//4、 获取 最近时间段 已注册的用户数量
export function timeRangRegisterApi(data) {
  return ajaxRequest({
    url: home + '/timeRangRegister',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取总的用户数量
export function totalCustomerApi(data) {
  return ajaxRequest({
    url: home + '/totalCustomer',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取总推荐客户数
export function totalCustomerNumApi(data) {
  return ajaxRequest({
    url: introduce + '/totalCustomerNum',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// =========================圆圈数字统计接口====================================

// 下同

// =========================直方图统计接口====================================

// //1、 获取 最近时间段 推荐的客户数量
// useradmin/Introduce/timeRangIntroduce

// 请求参数：areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00]

// //2、 获取 最近时间段 已到访客户数量
// useradmin/Introduce/timeRangVisited

// 请求参数：areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00]

// //3、 获取 最近时间段 已成交客户数量（包含已签约租、已签约售）
// useradmin/Introduce/timeRangTransed

// 请求参数：areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00]

// //4、 获取 最近时间段 已注册的用户数量
// useradmin/Home/timeRangRegister

// 请求参数：areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00]

// //5、 获取总的用户数量
// useradmin/Home/totalCustomer/{areaId}

// 请求参数：areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00]

// 请求方法：GET

// areaId, [2022-07-26 14:05:00,2022-07-25 14:05:00] 时间数组 都必填
